import { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { InstagramEmbed } from "react-social-media-embed"; // This dependency should be listed in package.json
import MKBox from "components/MKBox";
import PostSkeleton from "pages/Presentation/components/PostSkeleton";

function InstagramPost({ url }) {
  const [loading, setLoading] = useState(true);
  const containerRef = useRef(null);

  useEffect(() => {
    const containerNode = containerRef.current;
    if (!containerNode) return () => {};

    const observer = new MutationObserver(() => {
      const iframe = containerNode.querySelector("iframe");
      if (iframe) {
        if (iframe.contentDocument && iframe.contentDocument.readyState === "complete") {
          setLoading(false);
          observer.disconnect();
        } else {
          iframe.onload = () => {
            setLoading(false);
            observer.disconnect();
          };
        }
      }
    });

    observer.observe(containerNode, {
      childList: true,
      subtree: true,
    });

    const timeoutId = setTimeout(() => setLoading(false), 7000); // Fallback timeout

    return () => {
      observer.disconnect();
      clearTimeout(timeoutId);
    };
  }, [url]);

  return (
    <MKBox ref={containerRef} sx={{ position: "relative", minHeight: { xs: 480, sm: 520 } }}>
      {loading && (
        <MKBox sx={{ position: "absolute", top: 0, left: 0, width: "100%", zIndex: 1 }}>
          <PostSkeleton />
        </MKBox>
      )}
      <MKBox sx={{ opacity: loading ? 0 : 1, transition: "opacity 0.5s ease-in-out" }}>
        <InstagramEmbed url={url} width="100%" captioned={false} />
      </MKBox>
    </MKBox>
  );
}

InstagramPost.propTypes = {
  url: PropTypes.string.isRequired,
};

export default InstagramPost;
